export default "__VITE_ASSET__xwoxw9Kj__"